// extracted by mini-css-extract-plugin
module.exports = {"titleLink":"title-link___3myAR","anchor":"anchor___-SXrb","loading":"loading___247qM"};